import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Card, Flower } from '@barev/ui';
import { errorText, useI18n, useToast, useTRPC } from '@barev/web';
import { LanguagePicker } from './Profile.tsx';

const LANDING = import.meta.env.VITE_LANDING_URL ?? 'http://localhost:3000';

/** ONB-3: без согласия на обработку ПДн дальше не пускаем */
export function Consent() {
  const { t, locale } = useI18n();
  const trpc = useTRPC();
  const qc = useQueryClient();
  const toast = useToast();
  const consent = useMutation(
    trpc.client.consent.mutationOptions({
      onSuccess: (gift) => {
        if (gift) toast(t('client.consent.giftToast'));
        void qc.invalidateQueries();
      },
      onError: (e) => toast(errorText(t, e), 'error'),
    }),
  );
  return (
    <div className="app app--plain">
      <Card tone="pink" style={{ padding: 28 }}>
        <div className="bc-stack" style={{ gap: 18 }}>
          <Flower size={64} rotate={-10}>
            B
          </Flower>
          <h1 className="bc-h2">{t('client.consent.title')}</h1>
          <p style={{ margin: 0 }}>{t('client.consent.text')}</p>
          <a href={`${LANDING}/${locale}/privacy`} target="_blank" rel="noreferrer" style={{ fontWeight: 600 }}>
            {t('client.consent.policyLink')}
          </a>
          <Button block onClick={() => consent.mutate()} disabled={consent.isPending}>
            {t('client.consent.accept')}
          </Button>
        </div>
      </Card>
      <LanguagePicker />
    </div>
  );
}
